export default "__VITE_ASSET__94ef2bf1__"